import { render } from "./OpenIdCallback.vue?vue&type=template&id=9d7ebb56&scoped=true&lang=pug"
import script from "./OpenIdCallback.vue?vue&type=script&lang=js"
export * from "./OpenIdCallback.vue?vue&type=script&lang=js"

import "./OpenIdCallback.vue?vue&type=style&index=0&id=9d7ebb56&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d7ebb56"]])

export default __exports__